module.exports = __webpack_public_path__ + "teqbahn-assets/media/14.b2c90738.png";